import { useRef, useState } from 'react';
import { useToggle } from '../../../../../infra/small-tools/use-toggle';
export var useVerificationPopup = function () {
    var resolvePromiseRef = useRef(null);
    var verificationModal = useToggle();
    var _a = useState('email'), fieldToVerifyName = _a[0], setFieldToVerifyName = _a[1];
    var _b = useState(''), fieldToVerifyValue = _b[0], setFieldToVerifyValue = _b[1];
    var showVerificationPopup = function (_a) {
        var fieldName = _a.fieldName, fieldValue = _a.fieldValue;
        verificationModal.setOn();
        setFieldToVerifyName(fieldName);
        setFieldToVerifyValue(fieldValue);
        return new Promise(function (resolve) {
            resolvePromiseRef.current = resolve;
        });
    };
    var hideVerificationPopup = function (verified) {
        verificationModal.setOff();
        if (resolvePromiseRef.current) {
            resolvePromiseRef.current(verified);
            resolvePromiseRef.current = null;
        }
    };
    return {
        showVerificationPopup: showVerificationPopup,
        hideVerificationPopup: hideVerificationPopup,
        isVerificationPopupOpen: verificationModal.isOn,
        fieldToVerifyName: fieldToVerifyName,
        fieldToVerifyValue: fieldToVerifyValue,
    };
};
